import { render, staticRenderFns } from "./MetricsSelection.vue?vue&type=template&id=4bd2d895"
import script from "./MetricsSelection.vue?vue&type=script&lang=js"
export * from "./MetricsSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports